var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { Toast, Dialog } from 'vant';
import { getCookie, setCookie, isApp, removeCookie, removeStorage, isAppIOS, isAppAndriod } from '@/common/utils/tools';
import { getAfferentToken } from '../utils/bridge';
import { login } from '@lhb/bridge';
import { deepCopy, isMobile, dateFns } from '@lhb/func';
import * as Sentry from '@sentry/vue';
import { v4 } from 'uuid';
var errorTokenLen = 20; // token异常时的长度
// MockUrl
var mockUrl = 'https://yapi.lanhanba.com/mock/';
// https://yapi.lanhanba.com/mock/208/flow/project/list
// 默认URL
var baseUrl = '/api';
var baseUrlTerra = '/terra';
var baseUrlRes = '/res/api';
var applicationZeus = '/zeus-api';
var baseZeusUrl = '';
// 应用名
var applicationTerra = '';
// const applicationName = `/gateway/expandShop`;
// const applicationFlow = `/gateway/spotFlow`;
/**
 * 请求基础配置
 */
var baseConfig = {
    needCancel: true,
    isMock: false,
    mockId: 208,
    isDelObjEmptyProVal: true,
    errorConfig: {
        needHint: true,
        duration: 3000,
        showClose: false
    },
    successConfig: {
        needHint: true,
    }
};
/**
 * 异常处理
 */
var ApiError = /** @class */ (function (_super) {
    __extends(ApiError, _super);
    function ApiError(err) {
        var _this = this;
        var msg = err.message || err.msg || '';
        _this = _super.call(this, msg) || this;
        Object.assign(_this, err);
        _this.code = err.code;
        _this.result = err.result;
        return _this;
    }
    return ApiError;
}(Error));
function customEventOfSentry(token, extraConfig) {
    var platform = isMobile() ? 'h5' : '未知系统';
    if (isApp()) {
        platform = isAppIOS() ? 'ios' : (isAppAndriod() ? 'android' : '未知的移动设备'); // 平台
    }
    var customEvent = {
        message: '401',
        level: 'error',
        extra: __assign({ 
            // 添加任何额外的详细信息，你希望伴随这个事件
            platform: platform, issueStr: token, timestamp: dateFns.currentTime('', false) }, (extraConfig || {})),
    };
    Sentry.captureEvent(customEvent);
}
/**
 * 获取header
 * @param version 版本号
 * @param isPost 是否是 Post 请求
 */
export function getHeader(version, boolean) {
    if (version === void 0) { version = 1; }
    if (boolean === void 0) { boolean = false; }
    return __awaiter(this, void 0, void 0, function () {
        var userInfo, getLinhuibaCookie, headersToken, apikey, _a, token, uimsToken, TENANT_ID, EMPLOYEE_ID, DEVICE_ID, errorMsg, config, deviceId, deviceId_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    userInfo = getCookie('userInfo');
                    getLinhuibaCookie = getCookie('LINHUIBA_KEY');
                    headersToken = getCookie('UIMS_TOKEN') || getCookie('flow_token');
                    apikey = '';
                    if (!isApp()) return [3 /*break*/, 4];
                    if (!headersToken) return [3 /*break*/, 1];
                    apikey = getLinhuibaCookie ? getLinhuibaCookie.substring(2, getLinhuibaCookie.length - 8) : '';
                    headersToken = headersToken.substring(2, headersToken.length - 8);
                    if ((headersToken === null || headersToken === void 0 ? void 0 : headersToken.length) < errorTokenLen) {
                        customEventOfSentry(headersToken, {
                            msg: 'getCookie(`UIMS_TOKE`)时获取到非法的toke'
                        });
                    }
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, getAfferentToken()];
                case 2:
                    _a = _b.sent(), token = _a.token, uimsToken = _a.uimsToken, TENANT_ID = _a.TENANT_ID, EMPLOYEE_ID = _a.EMPLOYEE_ID, DEVICE_ID = _a.DEVICE_ID;
                    // if (!uimsToken || uimsToken?.length < errorTokenLen) {
                    // 部分接口不需要传token，此时如果未登录是没有token的，存在大量误报，原生友盟埋点了回调结果
                    if ((uimsToken === null || uimsToken === void 0 ? void 0 : uimsToken.length) < errorTokenLen) {
                        errorMsg = 'getToke 桥接事件获取到非法的toke';
                        customEventOfSentry(uimsToken, {
                            msg: errorMsg
                        });
                    }
                    // else {
                    //   setStorage('ONLY_APP_TOEKN', uimsToken);
                    // }
                    setCookie('TENANT_ID', TENANT_ID);
                    setCookie('EMPLOYEE_ID', EMPLOYEE_ID);
                    DEVICE_ID && setCookie('DEVICE_ID', DEVICE_ID);
                    apikey = token;
                    // const onlyInAppToken = getStorage('ONLY_APP_TOKEN');
                    headersToken = uimsToken;
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    if (userInfo) {
                        setCookie('TENANT_ID', JSON.parse(userInfo).TENANT_ID);
                        setCookie('EMPLOYEE_ID', JSON.parse(userInfo).EMPLOYEE_ID);
                        apikey = JSON.parse(userInfo).token;
                        headersToken = JSON.parse(userInfo).uims_token || headersToken;
                    }
                    _b.label = 5;
                case 5:
                    // 设置cookie，供大数据sdk抓取
                    // if (headersToken) {
                    //   setCookie('uims_token', headersToken);
                    // }
                    // if (userInfo) {
                    //   apikey = JSON.parse(userInfo).token;
                    // } else if (getLinhuibaCookie) {
                    //   apikey = getLinhuibaCookie.substring(2, getLinhuibaCookie.length - 8);
                    // }
                    // 本地开发
                    if (process.env.NODE_ENV === 'development') {
                        // apikey = getCookie('localToken') as string || apikey;
                        headersToken = getCookie('localUimsToken') || headersToken;
                    }
                    config = {
                        // Accept: 'application/vnd.linhuiba.v' + version + '+json',
                        Authorization: apikey ? 'Bearer ' + apikey : '',
                    };
                    if (headersToken) {
                        config['token'] = headersToken;
                    }
                    // 特殊处理，传入该参数才会开启gzip
                    if (version === -1) {
                        config.Accept = 'application/json';
                    }
                    if (boolean) {
                        Object.assign(config, {
                            'Content-Type': 'application/json',
                        });
                    }
                    deviceId = getCookie('DEVICE_ID');
                    if (deviceId && deviceId.length) {
                        config.deviceId = deviceId;
                    }
                    // H5环境下的deviceId
                    if (!isApp()) {
                        deviceId_1 = getCookie('deviceId');
                        if (!deviceId_1) {
                            deviceId_1 = v4();
                            setCookie('deviceId', deviceId_1);
                        }
                        config['deviceId'] = deviceId_1;
                    }
                    return [2 /*return*/, config];
            }
        });
    });
}
/**
 * 合并请求
 * @param extraConfig
 */
export function mergeConfig(extraConfig) {
    var _baseConfig = deepCopy(baseConfig);
    // 为了方便 第三个参数为boolean 值时可控制needHint值
    if (typeof extraConfig === 'boolean') {
        _baseConfig.errorConfig.needHint = extraConfig;
        return baseConfig;
    }
    else if (!extraConfig) {
        _baseConfig.errorConfig.needHint = true;
        return baseConfig;
    }
    else if (extraConfig.needHint) {
        _baseConfig.errorConfig.needHint = extraConfig.needHint;
    }
    return __assign(__assign({}, _baseConfig), extraConfig);
}
/**
 * 返回配置后的请求URl
 */
export function getRequestUrl(serviceName, config) {
    var isMock = config.isMock, isTerra = config.isTerra, isRes = config.isRes, isZeus = config.isZeus;
    if (isMock) { // mock地址
        return "" + mockUrl + (config.mockId || 149) + serviceName;
    }
    // const base = isTerra ? baseUrlTerra : baseUrl;
    var base = baseUrl;
    if (isRes) {
        base = baseUrlRes;
    }
    else if (isTerra) {
        base = baseUrlTerra;
    }
    else if (isZeus) {
        base = baseZeusUrl;
    }
    var prefix = '';
    if (isTerra) {
        prefix = applicationTerra;
    }
    else if (isZeus) {
        prefix = applicationZeus;
    }
    return "" + base + prefix + serviceName;
}
/**
 * 错误的请求处理
 * @param err
 * @param config
 */
export function fail(err, config) {
    if (axios.isCancel(err)) {
        throw new ApiError({
            code: 'cancel',
            msg: '您取消了请求',
        });
    }
    // @ts-ignore
    var _a = config.errorConfig, _b = _a.needHint, needHint = _b === void 0 ? true : _b, _c = _a.duration, duration = _c === void 0 ? 3000 : _c, _d = _a.showClose, showClose = _d === void 0 ? false : _d;
    var errorOptions = {
        type: 'error',
        duration: duration,
        showClose: showClose
    };
    if (err.response) {
        var _e = err.response, status = _e.status, _f = _e.data, message = _f.message, errMsg = _f.errMsg;
        switch (status) {
            case 401:
                errorOptions.message = '未登录';
                break;
            case 403:
                errorOptions.message = '未授权';
                break;
            case 404:
                errorOptions.message = '资源不存在';
                break;
            case 422:
                errorOptions.message = message || errMsg;
                break;
            case 429:
                errorOptions.message = '休息一会儿，稍后回来';
                break;
            case 500:
                errorOptions.message = '服务器出了小差~';
                break;
            case 501:
                errorOptions.message = '服务器出了小差~';
                break;
            case 502:
                errorOptions.message = '服务器网关出错~';
                break;
            case 503:
                errorOptions.message = '服务不可用~';
                break;
            case 504:
                errorOptions.message = '服务器连接超时~';
                break;
            case 505:
                errorOptions.message = 'HTTP版本不支持~';
                break;
            default:
                if (needHint) {
                    errorOptions.message = message;
                }
                break;
        }
        // 一些需要用户手动关闭的提示弹窗
        // 约定为420
        // 如，批量操作部分失败的情况
        if (errorOptions.message) {
            if (status === 401) {
                Toast({
                    message: errorOptions.message,
                    duration: 1000,
                    onClose: function () {
                        if (isApp()) { // app环境内
                            login();
                            return;
                        }
                        var isQyWx = window.navigator.userAgent.includes('wxwork'); // 判断是否在企业微信环境中
                        // 如果在企业微信浏览器内退出则跳转到console-pc响应式的登录页
                        if (isQyWx) {
                            // 需要把跳回PC登录相关的cookie去掉
                            removeCookie('flow_token');
                            removeStorage('flowLoginToken');
                            removeCookie('flow_account_id');
                            // window.location.href = process.env.CONSOLE_PC_URL || '/';
                            location.href = process.env.AREA_INSIGHT + '/login';
                        }
                        else {
                            // 401时在本地开发时跳到登录页
                            process.env.NODE_ENV === 'development'
                                ? (location.href = process.env.AREA_INSIGHT + '/login')
                                : (location.href = process.env.AREA_INSIGHT + '/login');
                        }
                    }
                });
                return null;
            }
            else if (status === 420) {
                needHint && Dialog({ message: message });
            }
            else {
                needHint && Dialog({ message: errorOptions.message });
            }
        }
        else {
            needHint && Dialog({ message: "\u672A\u77E5\u9519\u8BEF" });
        }
    }
    // if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
    //   Dialog({ message: `服务器响应超时` });
    // }
    throw new ApiError(err);
}
/**
 * 成功请求处理
 * remark: 暂时未做处理，预留
 * @param res
 */
export function success(res, config) {
    var needHint = config.successConfig.needHint;
    var result = res.data.result;
    if (config.project) {
        return res.data;
    }
    if (res.data) {
        return result || res.data;
    }
    else {
        if (needHint) {
            // Toast({
            //   message: msg,
            //   duration: 1000,
            //   onClose: () => {
            //   }
            // });
        }
    }
    throw new ApiError(res.data);
}
/**
 * 获取 axios 请求配置
 * @param requestConfig
 * @param axiosConfig
 */
export function getAxiosConfig(requestConfig, axiosConfig) {
    if (axiosConfig === void 0) { axiosConfig = {}; }
    var _a = requestConfig.needCancel, needCancel = _a === void 0 ? true : _a;
    // 需要cancel的时候，就加入cancelToken
    if (needCancel) {
        // axios会根据 cancelToken是否存在，进行打断。
        axiosConfig.cancelToken = {};
    }
    return axiosConfig;
}
